import propertyOrNull from '@99designs/utils/app/propertyOrNull';

export default {
    create,
    defaultProperties,
    fromJSON,
    equal,
};

function create(properties) {
    return Object.assign({}, defaultProperties(), properties);
}

function equal(obj1, obj2) {
    return obj1 && obj2 && obj1.userId === obj2.userId;
}

function defaultProperties() {
    return {
        userId: null,
        showUrl: null,
        name: null,
        avatarUrl: null,
    };
}

// Translate from HAL API to local data structure
function fromJSON(json) {
    if (!json) {
        return null;
    }

    const data = {
        userId: propertyOrNull(json, 'userId'),
        name: propertyOrNull(json, 'name') || propertyOrNull(json, 'displayName'),
        avatarUrl: propertyOrNull(json, 'avatarUrl'),
    };

    if (json.profileUrl) {
        data.profileUrl = json.profileUrl;
    } else if (json.showUrl) {
        data.profileUrl = json.showUrl;
    } else if (json._links && json._links.self) {
        data.profileUrl = json._links.self.href;
    }

    return data;
}



// WEBPACK FOOTER //
// ./~/@99designs/ddo/models/user.js